import React from 'react';
import PropTypes from 'prop-types';
import { StepHeader } from '@bingads-webui-campaign-react/linkedin-shared-components';

import { BudgetForm } from './components/budget-form';
import { useBudgetStepStyles } from './styles/budget-step-styles';

export const BudgetStep = ({
  data,
  onDataChange,
  error,
}) => {
  const classes = useBudgetStepStyles();

  return (
    <div className="linkedin-budget-step">
      <StepHeader
        title={_TL_('Budget & bids')}
        description={_TL_('Tell us how much you\'d like to spend and select your bid strategy.')}
      />
      <div className={classes.formContainer}>
        <BudgetForm
          data={data}
          onDataChange={onDataChange}
          error={error}
        />
      </div>
    </div>
  );
};

BudgetStep.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  error: PropTypes.shape({}).isRequired,
};
